import { AccessLevel } from "./generics";
import { BdaApplication } from "./BdaApplication";
import { Datasource } from "./Datasource";
import { Organization, Owner } from "./ControlPanel";

export interface DatasetFileType {
  columns?: any[];
  id?: number;
  location?: string;
  numberRows?: number;
  tableName?: string;
  type?: string;
  path?: string;
  delimiter?: string;
  details?: any;
  topic?: string;
  group?: string;
}

// TODO improve types
export interface Evaluation { }

export class BdaDataset {
  accessLevel?: AccessLevel;
  createDateTime?: string;
  created?: boolean;
  createdBy?: BdaApplication;
  createdByBdaId?: number;
  createdByServiceId?: number;
  datasetFileType?: DatasetFileType;
  datasource?: Datasource;
  description: string;
  evaluations?: Evaluation[];
  id?: number;
  infoConnection?: any;
  label?: string;
  name: string;
  order?: number;
  organization?: Organization;
  owner?: Owner;
  refId?: number;
  tags: string[];
  type?: string;
  updateDateTime?: string;
  deleteDateTime?: string;
  ref?: string;

  constructor() {
    this.name = "";
    this.description = "";
    this.type = "";
    this.tags = [];
    this.datasetFileType = { };
  }
}